import { Container } from '@mui/material';
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import ViewTab from '@components/ViewTab';

import { useViewable } from '@hooks/useViewable';

import { Spacer } from '@layouts/Layouts/BigTitleLayout';

import type { GeneticInformationObservationRecord } from '@models/genetic-information';

import { capitalizeAll } from '@utils/format';

import InformationList from './InformationList';

const messages = defineMessages({
  healthRisk: {
    id: 'geneticInformationPage.healthRisk',
    defaultMessage: 'health risk',
  },
  carrierStatus: {
    id: 'geneticInformationPage.carrierStatus',
    defaultMessage: 'carrier status',
  },
});

interface GeneticInformationPageProps {
  data: GeneticInformationObservationRecord[];
  loading: boolean;
  footer?: React.ReactNode;
}

const GeneticInformationPage: React.FC<GeneticInformationPageProps> = ({
  data,
  footer,
  loading,
}) => {
  const { formatMessage } = useIntl();

  const tabs = [
    { id: 'health-risk', value: formatMessage(messages.healthRisk) },
    { id: 'carrier-status', value: formatMessage(messages.carrierStatus) },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const filteredData = React.useMemo(
    () => data.filter((c) => c.code === activeTab.id),
    [activeTab.id, data]
  );

  useViewable(filteredData);

  return (
    <ContentLoader loading={loading}>
      <Container maxWidth="sm">
        <ViewTab
          changeTab={setActiveTab}
          selected={activeTab}
          tabArray={tabs}
        />
        <Spacer />
        <InformationList
          data={filteredData}
          type={capitalizeAll(activeTab.value)}
        />
        {footer}
      </Container>
    </ContentLoader>
  );
};

export default GeneticInformationPage;
